export default __webpack_public_path__ + "static/media/cro.271577af.svg";